export const hospitalOptions = [{
        label: "上海",
        options: [{
                label: "复旦大学附属肿瘤医院",
                value: "复旦大学附属肿瘤医院"
            },
            {
                label: "上海交通大学医学院附属瑞金医院",
                value: "上海交通大学医学院附属瑞金医院"
            },
            {
                label: "上海市第一人民医院",
                value: "上海市第一人民医院"
            },
            {
                label: "上海市第六人民医院",
                value: "上海市第六人民医院"
            },
            {
                label: "上海市华山医院",
                value: "上海市华山医院"
            },
            {
                label: "上海市中山医院",
                value: "上海市中山医院"
            },
            {
                label: "上海市儿童医院",
                value: "上海市儿童医院"
            },
            {
                label: "上海市第九人民医院",
                value: "上海市第九人民医院"
            },
            {
                label: "上海市仁济医院",
                value: "上海市仁济医院"
            },
            {
                label: "上海市长征医院",
                value: "上海市长征医院"
            },
            {
                label: "上海市东方医院",
                value: "上海市东方医院"
            },
            {
                label: "上海市同济医院",
                value: "上海市同济医院"
            },
            {
                label: "上海市精神卫生中心",
                value: "上海市精神卫生中心"
            },
            {
                label: "上海市中医医院",
                value: "上海市中医医院"
            },
            {
                label: "上海市第十人民医院",
                value: "上海市第十人民医院"
            },
        ],
    },
    {
        label: "北京",
        options: [{
                label: "北京协和医院",
                value: "北京协和医院"
            },
            {
                label: "北京大学人民医院",
                value: "北京大学人民医院"
            },
            {
                label: "北京大学第一医院",
                value: "北京大学第一医院"
            },
            {
                label: "北京中医医院",
                value: "北京中医医院"
            },
            {
                label: "北京天坛医院",
                value: "北京天坛医院"
            },
            {
                label: "北京安贞医院",
                value: "北京安贞医院"
            },
            {
                label: "北京积水潭医院",
                value: "北京积水潭医院"
            },
            {
                label: "北京儿童医院",
                value: "北京儿童医院"
            },
            {
                label: "北京友谊医院",
                value: "北京友谊医院"
            },
            {
                label: "北京宣武医院",
                value: "北京宣武医院"
            },
            {
                label: "北京朝阳医院",
                value: "北京朝阳医院"
            },
            {
                label: "北京肿瘤医院",
                value: "北京肿瘤医院"
            },
            {
                label: "北京妇产医院",
                value: "北京妇产医院"
            },
            {
                label: "北京胸科医院",
                value: "北京胸科医院"
            },
            {
                label: "北京回龙观医院",
                value: "北京回龙观医院"
            },
        ],
    },
    {
        label: "广州",
        options: [{
                label: "中山大学附属第一医院",
                value: "中山大学附属第一医院"
            },
            {
                label: "广东省人民医院",
                value: "广东省人民医院"
            },
            {
                label: "广州医科大学附属第一医院",
                value: "广州医科大学附属第一医院"
            },
            {
                label: "广州中医药大学第一附属医院",
                value: "广州中医药大学第一附属医院"
            },
            {
                label: "南方医科大学南方医院",
                value: "南方医科大学南方医院"
            },
            {
                label: "广州市妇女儿童医疗中心",
                value: "广州市妇女儿童医疗中心"
            },
            {
                label: "广州中医药大学第二附属医院",
                value: "广州中医药大学第二附属医院"
            },
            {
                label: "广州医科大学附属第二医院",
                value: "广州医科大学附属第二医院"
            },
            {
                label: "中山大学附属肿瘤医院",
                value: "中山大学附属肿瘤医院"
            },
            {
                label: "广东省中医院",
                value: "广东省中医院"
            },
            {
                label: "广州医科大学附属口腔医院",
                value: "广州医科大学附属口腔医院"
            },
            {
                label: "广州医科大学附属第三医院",
                value: "广州医科大学附属第三医院"
            },
            {
                label: "广州市第一人民医院",
                value: "广州市第一人民医院"
            },
            {
                label: "广州医科大学附属第五医院",
                value: "广州医科大学附属第五医院"
            },
            {
                label: "广州市红十字会医院",
                value: "广州市红十字会医院"
            },
        ],
    },
    // 其他城市可以按类似格式添加
];